const t = {
  type: "not_in_category",
  data: {
    property: "is_reply",
    values: [!1]
  }
}, _ = {
  type: "not_in_category",
  data: {
    property: "conversation_has_user_reply",
    values: [!1]
  }
}, e = {
  type: "not_in_category",
  data: {
    property: "is_bot",
    values: [!0]
  }
}, a = [
  t,
  _,
  e
], E = [t, e], o = {
  type: "category",
  data: {
    property: "new_conversation_state",
    values: ["closed"]
  }
}, s = [o, _], r = {
  type: "not_in_category",
  data: {
    property: "is_bot",
    values: [!0]
  }
};
export {
  o as CLOSES_ONLY_FILTER,
  s as CLOSES_WITH_USER_PART_FILTERS,
  a as CONVERSATION_PART_REPLIES_FILTERS,
  r as EXCLUDE_BOT_ADMIN,
  e as EXCLUDE_BOT_PARTS_FILTER,
  t as REPLIES_ONLY_FILTER,
  E as TEAMMATE_REPLIES_FILTERS,
  _ as USER_PART_EXISTS_FILTER
};
